import axios from '@/utils/axios'
import { AxiosPromise } from 'axios'

/**
 * Profile request
 *
 * @param params
 */
export const index = (params = {}): AxiosPromise => {
  return axios.get('/upgrades', { params })
}

export const show = (id: number, params = {}): AxiosPromise => {
  return axios.get(`/upgrades/${id}`, { params })
}

/**
 *
 * @param params
 */
export const store = (params = {}): AxiosPromise => {
  return axios.post('/upgrades', params)
}

/**
 *
 * @param id
 * @param params
 */
export const update = (id: number, params = {}): AxiosPromise => {
  return axios.put(`/upgrades/${id}`, params)
}

/**
 * Update attribute
 *
 * @param id
 * @param params
 */
export const updateAttribute = (id: number, params = {}): AxiosPromise => {
  return axios.put(`/upgrades/${id}/attribute`, params)
}

/**
 * @param id
 */
export const destroy = (id: number): AxiosPromise => {
  return axios.delete(`/upgrades/${id}`)
}
